import {
  Box,
  DialogTitle,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles'
import styles from './DiscoveryDialog.scss'

interface BaseDialogHeaderProps {
  closeDisabled?: boolean
  onClose: (event?: object, reason?: string) => void
}

const BaseDialogHeader = ({
  closeDisabled,
  onClose,
}: BaseDialogHeaderProps): JSX.Element => {
  const { palette } = useTheme()

  return (
    <DialogTitle sx={{ padding: '0px' }}>
      <Box display="flex" justifyContent="flex-end">
        <IconButton
          aria-label="close"
          disabled={closeDisabled}
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onClose?.(event as unknown as object, 'headerClose')
          }}
          sx={{ color: `${palette.gray1.main} !important` }}
        >
          <CloseIcon className={styles.discoveryDialogHeaderIcon} />
        </IconButton>
      </Box>
    </DialogTitle>
  )
}

export default BaseDialogHeader
